module.exports = __webpack_public_path__ + "static/GP-114d232894e979074701db2279a297f7.png";